import apiClient from './client';
import { Zone } from '../types/zone';

export interface ZonePriceResult {
  amount_rub: number;
  is_free: boolean;
  price_per_cell: number;
  area: number;
  center_dist: number;
  has_overlap: boolean;
}

export const getZonesInArea = (xMin: number, yMin: number, xMax: number, yMax: number) =>
  apiClient.get<Zone[]>('/zones/', { params: { x_min: xMin, y_min: yMin, x_max: xMax, y_max: yMax } });

export const getZonePrice = (xMin: number, yMin: number, xMax: number, yMax: number) =>
  apiClient.get<ZonePriceResult>('/zones/price', { params: { x_min: xMin, y_min: yMin, x_max: xMax, y_max: yMax } });

export const getMyZones = () =>
  apiClient.get<Zone[]>('/zones/my');

/** Creates a zone. For paid zones returns payment_url; for free zones returns null. */
export const createZone = (
  name: string,
  xMin: number, yMin: number,
  xMax: number, yMax: number,
  evictionTimeoutSec: number,
  returnPath?: string,
) =>
  apiClient.post<{ zone: Zone; payment_url: string | null }>('/zones/', {
    name, x_min: xMin, y_min: yMin, x_max: xMax, y_max: yMax,
    eviction_timeout_sec: evictionTimeoutSec, return_path: returnPath,
  });

export const updateZone = (id: number, name: string, evictionTimeoutSec: number) =>
  apiClient.put<Zone>(`/zones/${id}`, { name, eviction_timeout_sec: evictionTimeoutSec });

export const deleteZone = (id: number) =>
  apiClient.delete(`/zones/${id}`);

export const renewZone = (id: number, returnPath?: string) =>
  apiClient.post<{ payment_url: string }>(`/zones/${id}/renew`, returnPath ? { return_path: returnPath } : {});
